import { en } from './en';

export const ko = {
    COMMON: {
        ...en.COMMON,
        HHCCN: {
            LANGUAGE: {
                SECTION_TITLE: '언어',
            },
            CHANGES: {
                SECTION_TITLE: '가정 방문 의료 서비스 변경 고지(HHCCN)',
                FIELD1: '변경 예정 품목/서비스',
                FIELD2: '변경 이유',
                ADD_ITEM: '항목 추가',
            },
            STARTING_DATE: {
                SECTION_TITLE: '시작 날짜',
                LABEL: '변경 시작 날짜',
            },
            NOTICE_REASON: {
                SECTION_TITLE: '이 고지를 받는 이유는 무엇인가요?',
                OPTION1: {
                    LABEL: '귀하의 의사/의료제공자가 가정 방문 의료 서비스 관련 지시를 변경했거나 갱신하지 않았습니다.',
                    DESCRIPTION:
                        '가정 방문 의료 기관은 의사/의료제공자의 지시에 따라 치료/관리를 해야 합니다. 이러한 변경에 동의하지 않는 경우, 가정 방문 의료 기관 또는 가정 방문 의료 서비스를 지시한 의사/의료제공자와 상담하십시오.',
                },
                OPTION2: {
                    LABEL: '가정 방문 의료 기관은 위에 나열된 이유로 품목/서비스를 제공하지 않기로 했습니다.',
                    DESCRIPTION:
                        '여전히 가정 방문 의료 서비스가 필요하다고 생각하신다면, 타당한 지시가 있는 경우 다른 가정 방문 의료 기관을 알아보실 수 있습니다. 다른 가정 방문 의료 기관을 찾는 데 도움이 필요하신 경우 가정 방문 의료 서비스를 지시한 의사/의료제공자에게 문의하십시오. 다른 가정 방문 의료 기관으로부터 치료를 받는 경우 Medicare에 비용을 청구하라고 요청하실 수 있습니다.',
                },
            },
            GET_HELP: {
                SECTION_TITLE: '지원 또는 자세한 정보 얻기',
                CONTENT:
                    '이러한 변경에 대해 궁금한 점이 있으시면, 가정 방문 의료 기관 또는 가정 방문 의료 서비스를 지시한 의사/의료제공자에게 문의하십시오. 위에 나열된 품목/서비스를 받고 Medicare에 비용 청구서를 제출한 경우가 아니라면 해당 품목/서비스 지불에 대해 Medicare에 이의를 제기하실 수 없습니다.',
            },
            OPTIONAL_DETAILS: {
                SECTION_TITLE: '선택적 세부 정보',
            },
            PATIENT_SIGNATURE: {
                SECTION_TITLE: '서명',
                HEADING: '본 고지의 내용을 이해한다는 표시로 아래 서명해 주십시오',
                AGREE: '환자 또는 권한이 있는 대리인은 이 확인란을 선택하여 전자 서명으로 이 문서에 서명하는 것에 동의합니다.',
                AUTHORIZED_REP:
                    '권한이 있는 대리인으로 서명하는 경우 여기에 체크하고, 이름을 알아볼 수 있게 적거나 알아볼 수 없는 경우 정자체로 적어주십시오.',
            },
            ACCESSIBILITY: {
                CONTENT:
                    '귀하는 큰 활자체, 점자, 오디오 등 이용 가능한 형식으로 마켓플레이스의 정보를 받을 권리가 있습니다. 또한 차별을 받았다고 느끼는 경우 민원을 제기할 권리가 있습니다. 추가 정보에 대해서는, Medicare.gov/about-us/accessibility-nondiscrimination-notice를 참조하거나 1-800-MEDICARE (1-800-633-4227)로 문의하십시오. TTY 사용자는 1-877-486-2048번으로 문의하시면 됩니다.',
            },
        },
    },
};
